import axios from 'axios';

const brevoBaseUrl = 'https://api.sendinblue.com/v3/smtp/email';
const brevoApiKey = process.env.VUE_APP_BREVO_API_KEY;
const helloHardwiredName = 'Hardwired - Digital Solutions';
const helloHardwiredEmail = 'hello@hardwired.pt';

export default {
    sendInfoEmail(data, callback) {
        const payload = {
            sender: {
                name: helloHardwiredName,
                email: helloHardwiredEmail
            },
            replyTo: {
                name: data.name,
                email: data.email
            },
            to: [
                {
                    email: helloHardwiredEmail,
                    name: helloHardwiredName
                }
            ],
            subject: '[Hardwired] Pedido de Informações',
            textContent: `Nome: ${data.name}\nEmail: ${data.email}\n\n${data.message}`
        };
        axios.post(brevoBaseUrl,
            payload, {
            headers: {
                'Content-Type': 'application/json',
                'api-key': brevoApiKey,
            },
        }).then((response) => {
            console.log('Response:', JSON.stringify(response.data));
            callback(true);
        }).catch((error) => {
            console.log('Error:', JSON.stringify(error));
            callback(false);
        });
    },
}
